/* eslint-disable no-nested-ternary */
import React from 'react';
import moment from 'moment';

import CardTooltip from '../../CardTooltip';
import Loading from '../../Loading';
import Icon from '../../Icons';

import { useGlobal } from '../../../contexts/Global/context';

import * as S from './styles';
import * as Styles from '../styles';

function DatepickerRange({ field, loading, onChange, inputReadOnly, icon: InputIcon, ...rest }) {
    const { contrastTheme } = useGlobal();
    function handleChange(value) {
        let treatedValue = null;

        if (value?.length === 2) {
            treatedValue = [];

            treatedValue[0] = value[0] && value[0].toISOString();
            treatedValue[1] = value[1] && value[1].toISOString();
        }

        if (typeof onChange === 'function') onChange({ id: field.id, value: treatedValue });
    }

    let treatedValue = [];

    if (field.value?.length === 2) {
        treatedValue = [];

        treatedValue[0] = field.value[0] && moment(field.value[0]);
        treatedValue[1] = field.value[1] && moment(field.value[1]);
    }

    const defaultProps = {
        format: 'DD/MM/YYYY',
        placeholder: field.placeholder || ['DD/MM/AAAA', ''],
        separator: '',
        value: treatedValue,
        inputReadOnly: true,
        allowEmpty: [true, true],
        suffixIcon: (
            <Icon
                name="date_range"
                color={field.error && !contrastTheme ? '#EC130F' : contrastTheme ? '#FFF333' : '#EC6E0C'}
                size={20}
            />
        ),
    };

    return (
        <Styles.FormGroup>
            <label htmlFor="first-label-range">
                {field.label && `${field.label} ${!field.required && !field.disabled ? ' (opcional)' : ''}`}
                {field.help && (
                    <CardTooltip message={field.help}>
                        <Styles.ContainerHelp>
                            <Icon name="info" size={18} />
                        </Styles.ContainerHelp>
                    </CardTooltip>
                )}
            </label>
            <S.ContainerInput>
                <S.StyledDatepickerRange
                    showOneCalendar
                    disabled={field.disabled}
                    value={field.value}
                    id={field.id}
                    className={`${field.error ? 'error' : ' '} ${field.disabled ? 'disabled' : ' '}`}
                    onChange={handleChange}
                    {...defaultProps}
                    {...rest}
                />
                {loading && <Loading padding="0px" size={20} />}
                {!loading && InputIcon && (
                    <div className="icon-container">
                        <InputIcon color={contrastTheme ? '#FFFFFF' : '#EC6E0C'} />
                    </div>
                )}
            </S.ContainerInput>
            {field.error && <Styles.SpanError>{field.error}</Styles.SpanError>}
        </Styles.FormGroup>
    );
}

export default DatepickerRange;
